import Loading from 'components/Loading';
import Page404 from 'components/Page404';
import { Suspense } from 'react';
import { createHashRouter } from 'react-router-dom';
import PrivateRoutes from './PrivateRoutes';

const router = createHashRouter([
  ...PrivateRoutes,
  {
    path: '/notFound',
    element: (
      <Suspense fallback={<Loading />}>
        <Page404 />
      </Suspense>
    ),
  },
  {
    path: '*',
    element: (
      <Suspense fallback={<Loading />}>
        <Page404 />
      </Suspense>
    ),
  },
]);

export default router;
